import { FormattedMessage } from 'react-intl';

export const BooleanDisplay = <T extends object>(props: { keys: (keyof T)[]; obj: T; keyDisplay?: Map<keyof T, React.ReactNode> }) => {
    return props.keys.map((key) => {
        const value = props.obj[key];
        const keyDisplay = props.keyDisplay?.get(key) || String(key).replace(/_/g, ' ');
        return (
            <div
                key={String(key)}
                className='self-stretc inline-flex flex-1 flex-col items-start justify-start gap-[3px]'>
                <span className='text-brand-muted justify-start text-base font-medium'>{keyDisplay}</span>
                <span
                    className={`inline-flex items-start justify-center rounded-full px-2 py-1 ${value ? 'bg-status-success text-always-white' : 'bg-status-warning text-always-white'}`}>
                    <span className='text-always-white justify-start text-center text-sm font-semibold'>
                        {value ? (
                            <FormattedMessage
                                id='enabled'
                                defaultMessage='Enabled'
                            />
                        ) : (
                            <FormattedMessage
                                id='disabled'
                                defaultMessage='Disabled'
                            />
                        )}
                    </span>
                </span>
            </div>
        );
    });
};
